class BlockGallery {

	constructor(){

		let panelsContainer = document.querySelectorAll(".block-gallery-container");

		panelsContainer.forEach( (container) => {
			let panelsInner = container.querySelector(".block-gallery-inner");

			let mm = gsap.matchMedia();

			mm.add("(min-width: 768px)", () => {

				if( panelsInner.offsetWidth > innerWidth ) {

					gsap.to(panelsInner, {
						x: -(panelsInner.offsetWidth - innerWidth),
						ease: "none", // <-- IMPORTANT!
						scrollTrigger: {
							trigger: container,
							pin: true,
							scrub: 0.5,
							end: "+=" + (panelsInner.offsetWidth * 1.5 - innerWidth)
						}
					});

				}

			});
		});

	}

	resize(){



	}

}
